import { useSyncExternalStore } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Kuryer ish smenasi holati (server: /courier-tracking/shift). Bitta umumiy
// holat — CourierPage'dagi tugma va CourierTrackingInit (native GPS) ikkalasi
// shuni ishlatadi.
let state = { loaded: false, active: false, startedAt: null, busy: false };
const subs = new Set();
const set = (patch) => { state = { ...state, ...patch }; subs.forEach(f => f()); };
const fromShift = (shift) => ({ loaded: true, active: !!shift, startedAt: shift?.startedAt || null });

export const useCourierShift = () => useSyncExternalStore(
  (f) => { subs.add(f); return () => subs.delete(f); },
  () => state,
);

export async function loadShift() {
  try {
    const r = await axios.get(`${API}/courier-tracking/shift`);
    set(fromShift(r.data.shift));
  } catch { /* tarmoq xatosi — holat o'zgarmaydi */ }
}

export async function toggleShift() {
  if (state.busy) return false;
  set({ busy: true });
  try {
    const r = await axios.post(`${API}/courier-tracking/shift/${state.active ? 'end' : 'start'}`);
    set({ ...fromShift(r.data.shift), busy: false });
    return true;
  } catch {
    set({ busy: false });
    return false;
  }
}

export const resetShift = () => set({ loaded: false, active: false, startedAt: null, busy: false });
